import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import Card from '../components/Card'
import List, { ListItem } from '../components/List'
import PageHeading from '../components/PageHeading'

interface LabelTraceProgressProps {
  codes: string[]
}

export default class LabelTraceProgress
  extends Component<LabelTraceProgressProps> {
  get progress (): ListItem[] {
    return this.props.codes.map(code => {
      return { value: code }
    })
  }

  render () {
    return (
      <Card>
        <PageHeading text={i18n("Progress")} />
        <List items={this.progress} />
      </Card>
    )
  }
}
